import { createSlatePlugin } from "platejs";
import { toNodeProps } from "./withNodeProps";

export const IframePlugin = createSlatePlugin({
  key: "iframe",
  node: {
    isElement: true,
    isVoid: true,
  },
  parsers: {
    html: {
      deserializer: {
        rules: [
          {
            validNodeName: "IFRAME",
          },
        ],
        toNodeProps: toNodeProps,
      },
    },
  },
});
